<ng-container matColumnDef="datetime_picker">
    <mat-form-field [class]="classes" appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ label }}</mat-label>
      <input matInput readonly (dateTimeChange)="onDateTimeChanged($event)" [(ngModel)]="selectedDateTime" [name]="pickerName" [required]="isRequired" [disabled]="isDisabled" [owlDateTime]="dt1" [min]="min" [max]="max" placeholder="">
      <button type="button" matSuffix mat-icon-button [disabled]="isDisabled" [owlDateTimeTrigger]="dt1" [matTooltip]="selectTooltip"><mat-icon>{{ pickerType == 'timer' ? 'schedule' : 'today' }}</mat-icon></button>
      <button type="button" matSuffix mat-icon-button *ngIf="!isRequired && selectedDateTime" [disabled]="isDisabled" (click)="onDateTimeRemoved()" [matTooltip]="removeTooltip"><mat-icon>close</mat-icon></button>
      <mat-hint>{{ hint }}</mat-hint>
      <mat-error *ngIf="isRequired && !selectedDateTime">{{ errorText }}</mat-error>
    </mat-form-field>
    <owl-date-time [pickerType]="pickerType" [pickerMode]="'dialog'" #dt1></owl-date-time>
</ng-container>

